export default {
    "kt": "Khởi tạo",
    "cbpu": "Chuẩn bị pick up",
    "cpu": "Chờ pick up",
    "cxk": "Chờ xuất kho",
    "dxk": "Đã xuất kho",
    "h": "Hủy",
}
